import React from "react";
import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";
import styles from "./Cart.module.css";

const WHATSAPP_NUMBER = "971567575811";

function Cart() {
  const { items, removeFromCart, totalPrice } = useCart();

  const handleCheckoutWhatsApp = () => {
    const lines = items.map(
      (i) => `- ${i.name} x${i.qty} (AED ${i.price * i.qty})`
    );
    const message =
      `Hi Tripontourism! I'd like to book the following:\n\n` +
      lines.join("\n") +
      `\n\nTotal: AED ${totalPrice}`;

    const link = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
      message
    )}`;
    window.open(link, "_blank", "noopener,noreferrer");
  };

  return (
    <div className={styles.page}>
      <div className="container">
        <h1 className={styles.title}>Your Cart</h1>

        {items.length === 0 ? (
          <div className={styles.empty}>
            <p>Your cart is empty.</p>
            <Link to="/" className={styles.continueLink}>
              Browse safari packages &rarr;
            </Link>
          </div>
        ) : (
          <>
            <div className={styles.list}>
              {items.map((item) => (
                <div key={item.id} className={styles.row}>
                  <div>
                    <p className={styles.itemName}>{item.name}</p>
                    <p className={styles.itemMeta}>
                      Qty {item.qty} &middot; AED {item.price} each
                    </p>
                  </div>
                  <div className={styles.rowRight}>
                    <span className={styles.itemTotal}>
                      AED {item.qty * item.price}
                    </span>
                    <button
                      type="button"
                      className={styles.removeBtn}
                      onClick={() => removeFromCart(item.id)}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              ))}
            </div>

            <div className={styles.summary}>
              <span>Total</span>
              <span className={styles.totalPrice}>AED {totalPrice}</span>
            </div>

            <button
              type="button"
              className={styles.checkoutBtn}
              onClick={handleCheckoutWhatsApp}
            >
              Checkout via WhatsApp
            </button>

            <Link to="/" className={styles.continueLink}>
              &larr; Continue browsing
            </Link>
          </>
        )}
      </div>
    </div>
  );
}

export default Cart;
